import { useEffect, useState } from "react";
import api from "./api";

// Logo de la farmacia: se carga una vez y se comparte entre cabecera y PDF.
let cache = { url: null, dataUrl: null, ratio: null, loaded: false };
const listeners = new Set();

function toDataUrl(blob) {
  return new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(blob); });
}

function ratioOf(src) {
  return new Promise((res) => { const i = new Image(); i.onload = () => res(i.width / i.height || 1); i.onerror = () => res(1); i.src = src; });
}

export async function reloadLogo() {
  try {
    const r = await api.get("/branding/logo", { responseType: "blob" });
    if (r.status === 204 || !r.data?.size) throw new Error("sin logo");
    if (cache.url) URL.revokeObjectURL(cache.url);
    const dataUrl = await toDataUrl(r.data);
    cache = { url: URL.createObjectURL(r.data), dataUrl, ratio: await ratioOf(dataUrl), loaded: true };
  } catch {
    cache = { url: null, dataUrl: null, ratio: null, loaded: true };
  }
  listeners.forEach((fn) => fn(cache));
  return cache;
}

export function getLogo() {
  return cache;
}

export function useLogo() {
  const [state, setState] = useState(cache);
  useEffect(() => {
    listeners.add(setState);
    if (!cache.loaded) reloadLogo();
    return () => listeners.delete(setState);
  }, []);
  return state;
}
